<template>
    <div id="contents" class="contents-popular contents">

        <div class="breadcrumb">
            <ul>
                <li><router-link :to="{name: 'Index'}">TOP</router-link></li>
                <li v-if="breadcrumb.length > 0 && breadcrumb[0] === 'fullList'"><router-link :to="{name: 'FullList'}">Full List</router-link></li>
                <li v-if="breadcrumb.length > 0 && breadcrumb[0] === 'region'"><router-link :to="{name: 'FullList', query: { tab: 'region'}}">By Region</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'hokkaido'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'hokkaido'}}">Hokkaido</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'tohoku'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'tohoku'}}">Tohoku</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'hokuriku'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'hokuriku'}}">Hokuriku</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'kanto'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'kanto'}}">Kanto</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'tokai'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'tokai'}}">Tokai</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'kansai'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'kansai'}}">Kansai</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'chugoku'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'chugoku'}}">Chugoku</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'shikoku'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'shikoku'}}">Shikoku</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'kyushu'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'kyushu'}}">Kyushu</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'okinawa'"><router-link :to="{name: 'FullList', query: { tab: 'region', map: 'okinawa'}}">Okinawa</router-link></li>
                <li v-if="breadcrumb.length > 0 && breadcrumb[0] === 'category'"><router-link :to="{name: 'FullList', query: { tab: 'category'}}">By Category</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'history_and_culture'"><router-link :to="{name: 'FullList', hash: '#history_and_culture', query: { tab: 'category'}}">History And Culture</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'nature'"><router-link :to="{name: 'FullList', hash: '#nature', query: { tab: 'category'}}">Nature</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'religion_and_beliefs'"><router-link :to="{name: 'FullList', hash: '#religion_and_beliefs', query: { tab: 'category'}}">Religion And Beliefs</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'cultural_experiences'"><router-link :to="{name: 'FullList', hash: '#cultural_experiences', query: { tab: 'category'}}">Cultural Experiences</router-link></li>
                <li v-if="breadcrumb.length > 0 && breadcrumb[0] === 'planYourVisit'"><router-link :to="{name: 'PlanYourVisit', query: { tab: 'half'}}">Plan Your Visit</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'half'"><router-link :to="{name: 'PlanYourVisit', query: { tab: 'half'}}">Half-Day Trips</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'day1'"><router-link :to="{name: 'PlanYourVisit', query: { tab: 'day1'}}">1-Day Trips</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'day2'"><router-link :to="{name: 'PlanYourVisit', query: { tab: 'day2'}}">2-Day Trips</router-link></li>
                <li v-if="breadcrumb.length > 1 && breadcrumb[1] === 'day3'"><router-link :to="{name: 'PlanYourVisit', query: { tab: 'day3'}}">3-Day Trips</router-link></li>
                <li>Thrills and Spills: An Exciting Climb and Healing Hot Springs</li>
            </ul>
        </div>

        <div class="ttlMain">
            <ul>
                <li class="prev"><router-link :to="{name: 'Popular', params: {id: '5bca15cb-078a-4992-a6de-81631516a607', page: 'about'}}">Previous</router-link></li>
                <li class="ttlWraper"><h1 class="ttl">Thrills and Spills: An Exciting Climb and Healing Hot Springs</h1></li>
                <li class="next"><router-link :to="{name: 'Popular', params: {id: '5bca15cb-078a-4992-a6de-81631516a607', page: 'about'}}">Next</router-link></li>
            </ul>
        </div>

        <div class="tabMenu">
            <ul>
                <li
                    :class="[page === 'about' ? 'active': '', 'about']"
                    role="link" tabindex="0"
                    v-on:click="showPage('about')"
                    v-on:keyup.enter="showPage('about')"
                    v-on:keyup.space="showPage('about')"
                >About</li>
                <li
                    :class="[page === 'travelInfo' ? 'active': '']"
                    role="link" tabindex="0"
                    v-on:click="showPage('travelInfo')"
                    v-on:keyup.enter="showPage('travelInfo')"
                    v-on:keyup.space="showPage('travelInfo')"
                >Travel Info</li>
                <li v-if="hasPdf" class="pdf"><a href="javascript:void(0)" v-on:click="download">Download PDF</a></li>
            </ul>
        </div>

        <!-- （１）アバウトページ -->
        <div v-show="page === 'about'" class="contentAbout">

            <div class="main-visual">
                <div class="main-video">
                    <video-player ref="videoPlayer"
                                    :options="{
                                        controls: false,
                                        preload: 'none',
                                        fluid: true,
                                        poster: 'https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/about.jpg',
                                        sources: [{src:'https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/streaks/ainofurusato.m3u8'}]}">
                    </video-player>
                </div>
            </div>

            <!-- The Story -->
            <div class="sectionStory">
                <h2 class="ttl">The Story</h2>
                <div class="para">
                    <div class="img">
                        <p><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                        <p><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                    </div>
                    <div class="txt">
                        <p>
The majority of Japanese indigo dye is produced today in Tokushima Prefecture. Indigo dyeing began in Tokushima over 800 years ago in the Yoshino River basin. The flooding of the river would carry fertile soil to the basin, making it ideal for growing indigo. The river also allowed for the transportation of the finished product.<br>
Tokushima’s indigo dye was especially popular in the 18th and 19th centuries and was used in many household items and clothing. A British scholar who visited Japan in the 19th century was impressed by the rich, deep hue and called it “Japan blue.” Merchants who made fortunes from the trade built extravagant mansions in towns near Yoshino River, with fire barrier walls called udatsu to protect them. The udatsu eventually took on a more decorative function and became increasingly glamorous as the merchants showed off their wealth. Many of these buildings remain today and visitors can explore the beautiful townscape around the Yoshino River.<br>
Indigo dyeing as an industry declined as synthetic dyes took over. But recently the traditional dyeing process has been reevaluated and dedicated craftsmen around Japan have kept the craft alive. Tokushima’s hugely popular Awa Dance Festival and Awa Ningyo Joruri puppet theater are legacies of the prosperity generated by the indigo trade.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Cultural Properties -->
            <div class="sectionCulturalProperties">
                <h2 class="ttl">Cultural <br class="sp-only">Properties</h2>
                <div class="para -reverse">
                    <div class="img">
                        <p><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                    </div>
                    <div class="txt">
                        <h3 class="ttl">Nageiredo Hall</h3>
                        <p>
The majority of Japanese indigo dye is produced today in Tokushima Prefecture. Indigo dyeing began in Tokushima over 800 years ago in the Yoshino River basin. The flooding of the river would carry fertile soil to the basin, making it ideal for growing indigo. The river also allowed for the transportation of the finished product.<br>
Tokushima’s indigo dye was especially popular in the 18th and 19th centuries and was used in many household items and clothing. A British scholar who visited Japan in the 19th century was impressed by the rich, deep hue and called it “Japan blue.” Merchants who made fortunes from the trade built extravagant mansions in towns near Yoshino River, with fire barrier walls called udatsu to protect them. The udatsu eventually took on a more decorative function and became increasingly glamorous as the merchants showed off their wealth. Many of these buildings remain today and visitors can explore the beautiful townscape around the Yoshino River.<br>
Indigo dyeing as an industry declined as synthetic dyes took over. But recently the traditional dyeing process has been reevaluated and dedicated craftsmen around Japan have kept the craft alive. Tokushima’s hugely popular Awa Dance Festival and Awa Ningyo Joruri puppet theater are legacies of the prosperity generated by the indigo trade.
                        </p>
                        <div class="btn1">
                            <ul>
                                <li><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="para">
                    <div class="img">
                        <p><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                    </div>
                    <div class="txt">
                        <h3 class="ttl">Nageiredo Hall</h3>
                        <p>
The majority of Japanese indigo dye is produced today in Tokushima Prefecture. Indigo dyeing began in Tokushima over 800 years ago in the Yoshino River basin. The flooding of the river would carry fertile soil to the basin, making it ideal for growing indigo. The river also allowed for the transportation of the finished product.<br>
Tokushima’s indigo dye was especially popular in the 18th and 19th centuries and was used in many household items and clothing. A British scholar who visited Japan in the 19th century was impressed by the rich, deep hue and called it “Japan blue.” Merchants who made fortunes from the trade built extravagant mansions in towns near Yoshino River, with fire barrier walls called udatsu to protect them. The udatsu eventually took on a more decorative function and became increasingly glamorous as the merchants showed off their wealth. Many of these buildings remain today and visitors can explore the beautiful townscape around the Yoshino River.<br>
Indigo dyeing as an industry declined as synthetic dyes took over. But recently the traditional dyeing process has been reevaluated and dedicated craftsmen around Japan have kept the craft alive. Tokushima’s hugely popular Awa Dance Festival and Awa Ningyo Joruri puppet theater are legacies of the prosperity generated by the indigo trade.
                        </p>
                        <div class="btn1">
                            <ul>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="para -reverse">
                    <div class="img">
                        <p><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                        <p><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                    </div>
                    <div class="txt">
                        <h3 class="ttl">Nageiredo Hall</h3>
                        <p>
The majority of Japanese indigo dye is produced today in Tokushima Prefecture. Indigo dyeing began in Tokushima over 800 years ago in the Yoshino River basin. The flooding of the river would carry fertile soil to the basin, making it ideal for growing indigo. The river also allowed for the transportation of the finished product.<br>
Tokushima’s indigo dye was especially popular in the 18th and 19th centuries and was used in many household items and clothing. A British scholar who visited Japan in the 19th century was impressed by the rich, deep hue and called it “Japan blue.” Merchants who made fortunes from the trade built extravagant mansions in towns near Yoshino River, with fire barrier walls called udatsu to protect them. The udatsu eventually took on a more decorative function and became increasingly glamorous as the merchants showed off their wealth. Many of these buildings remain today and visitors can explore the beautiful townscape around the Yoshino River.<br>
Indigo dyeing as an industry declined as synthetic dyes took over. But recently the traditional dyeing process has been reevaluated and dedicated craftsmen around Japan have kept the craft alive. Tokushima’s hugely popular Awa Dance Festival and Awa Ningyo Joruri puppet theater are legacies of the prosperity generated by the indigo trade.
                        </p>
                        <div class="btn1 -withCaption">
                            <ul>
                                <li><span>midashi</span><a href="#">Read Reviews</a></li>
                                <li><span>midashi</span><a href="#">Read Reviews</a></li>
                                <li><span>midashi</span><a href="#">Read Reviews</a></li>
                                <li><span>midashi</span><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- （２）トラベルインフォページ -->
        <div class="contentTravelInfo" :class="{ '-hide' : page !== 'travelInfo' }">

            <div class="main-visual" data-mv="travelinfo">
                <div class="main-video">
                    <video src="#" loop muted></video>
                    <div class="main-img"><img
                        src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/travel.jpg"
                        alt=""></div>
                </div>
            </div>

            <div class="ttlWrap">
                <h2 class="ttl">Travel Info</h2>
                <div class="anchorLink">
                    <ul>
                        <li><a href="javascript:void(0)" v-scroll-to="{ el: '#recommend', offset: -200 }"><span>Recommended Routes</span></a></li>
                        <li><a href="javascript:void(0)" v-scroll-to="{ el: '#access', offset: -200 }"><span>Access</span></a></li>
                    </ul>
                </div>
            </div>

            <div class="para">
                <div class="img"><span></span></div>
                <div class="txt">
                    <h3 class="ttl">Tourist Attractions</h3>
                    <h4 class="ttlSub">Sub Title</h4>
                    <p class="txt1">Misasa Town and its surrounding area in Tottori Prefecture boast attractions that will pique the interest of thrill-seekers and visitors seeking a place to unwind. Getting a close-up view of Sanbutsuji Temple’s cliff-clinging Nageiredo Hall on Mt. Mitoku requires climbing a path considered the most dangerous approach to any of Japan’s national treasures. The hall can also be seen through binoculars near the foot of the mountain. The picturesque town’s numerous hot springs attract visitors and locals alike, and worshippers at Misasa Jinja (Shinto shrine) can even purify their hands at the entrance with hot spring water. The Misasa Violin Museum is also well worth a visit.</p>
                    <div class="btn1">
                        <ul>
                            <li><a href="#">Read Reviews</a></li>
                        </ul>
                    </div>
                    <h4 class="ttlSub">Sub Title</h4>
                    <p class="txt1">Misasa Town and its surrounding area in Tottori Prefecture boast attractions that will pique the interest of thrill-seekers and visitors seeking a place to unwind. Getting a close-up view of Sanbutsuji Temple’s cliff-clinging Nageiredo Hall on Mt. Mitoku requires climbing a path considered the most dangerous approach to any of Japan’s national treasures. The hall can also be seen through binoculars near the foot of the mountain. The picturesque town’s numerous hot springs attract visitors and locals alike, and worshippers at Misasa Jinja (Shinto shrine) can even purify their hands at the entrance with hot spring water. The Misasa Violin Museum is also well worth a visit.</p>
                    <div class="btn1">
                        <ul>
                            <li><a href="#">Read Reviews</a></li>
                        </ul>
                    </div>
                    <h4 class="ttlSub">Sub Title</h4>
                    <p class="txt1">Misasa Town and its surrounding area in Tottori Prefecture boast attractions that will pique the interest of thrill-seekers and visitors seeking a place to unwind. Getting a close-up view of Sanbutsuji Temple’s cliff-clinging Nageiredo Hall on Mt. Mitoku requires climbing a path considered the most dangerous approach to any of Japan’s national treasures. The hall can also be seen through binoculars near the foot of the mountain. The picturesque town’s numerous hot springs attract visitors and locals alike, and worshippers at Misasa Jinja (Shinto shrine) can even purify their hands at the entrance with hot spring water. The Misasa Violin Museum is also well worth a visit.</p>
                    <div class="btn1">
                        <ul>
                            <li><a href="#">Read Reviews</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="para -reverse">
                <div class="img"><span></span></div>
                <div class="txt">
                    <h3 class="ttl">Activities</h3>
                    <p class="txt1">Misasa Town and its surrounding area in Tottori Prefecture boast attractions that will pique the interest of thrill-seekers and visitors seeking a place to unwind. Getting a close-up view of Sanbutsuji Temple’s cliff-clinging Nageiredo Hall on Mt. Mitoku requires climbing a path considered the most dangerous approach to any of Japan’s national treasures. The hall can also be seen through binoculars near the foot of the mountain. The picturesque town’s numerous hot springs attract visitors and locals alike, and worshippers at Misasa Jinja (Shinto shrine) can even purify their hands at the entrance with hot spring water. The Misasa Violin Museum is also well worth a visit.</p>
                    <div class="btn1">
                        <ul>
                            <li><a href="#">Read Reviews</a></li>
                            <li><a href="#">Read Reviews</a></li>
                            <li><a href="#">Read Reviews</a></li>
                            <li><a href="#">Read Reviews</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="para">
                <div class="img"><span></span></div>
                <div class="txt">
                    <h3 class="ttl">Local Specialties</h3>
                    <p class="txt1">Misasa Town and its surrounding area in Tottori Prefecture boast attractions that will pique the interest of thrill-seekers and visitors seeking a place to unwind. Getting a close-up view of Sanbutsuji Temple’s cliff-clinging Nageiredo Hall on Mt. Mitoku requires climbing a path considered the most dangerous approach to any of Japan’s national treasures. The hall can also be seen through binoculars near the foot of the mountain. The picturesque town’s numerous hot springs attract visitors and locals alike, and worshippers at Misasa Jinja (Shinto shrine) can even purify their hands at the entrance with hot spring water. The Misasa Violin Museum is also well worth a visit.</p>
                    <div class="btn1 -withCaption">
                        <ul>
                            <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                            <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                            <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                            <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="vrVideo">
                <div class="ttl">VR Videos</div>
                <div class="articles">
                    <div class="articlesInner">
                        <!-- PC用カルーセル -->
                        <Carousel v-bind="settings" class="d-flex">
                            <Slide>
                                <div class="articleItem" @click="openVr('Yn8dk04tirc')">
                                    <p class="img">
                                        <img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt="" />
                                    </p>
                                    <p class="txt">Daisetsuzan and the Sounkyo Gorge</p>
                                </div>
                            </Slide>
                            <Slide>
                                <div class="articleItem" @click="openVr('Yn8dk04tirc')">
                                    <p class="img">
                                        <img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt="" />
                                    </p>
                                    <p class="txt">Daisetsuzan and the Sounkyo Gorge</p>
                                </div>
                            </Slide>
                            <Slide>
                                <div class="articleItem" @click="openVr('Yn8dk04tirc')">
                                    <p class="img">
                                        <img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt="" />
                                    </p>
                                    <p class="txt">Daisetsuzan and the Sounkyo Gorge</p>
                                </div>
                            </Slide>
                        </Carousel>

                        <!-- スマホ用リスト -->
                        <div class="sp-only">
                            <div class="articleItem" @click="openVr('Yn8dk04tirc')">
                                <p class="img"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                                <p class="txt">Daisetsuzan and the Sounkyo Gorge</p>
                            </div>
                            <div class="articleItem" @click="openVr('Yn8dk04tirc')">
                                <p class="img"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                                <p class="txt">Daisetsuzan and the Sounkyo Gorge</p>
                            </div>
                            <div class="articleItem" @click="openVr('Yn8dk04tirc')">
                                <p class="img"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/ainofurusato/story.jpg" alt=""></p>
                                <p class="txt">Daisetsuzan and the Sounkyo Gorge</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="recommendedRoute" id="recommend">
                <h3 class="ttl">Recommended Routes</h3>
                <p class="lead1">
                    Times and route may vary depending on the individual's interests and other factors.
                </p>
                <div class="para -route1">
                    <p class="img"><span></span></p>
                    <p class="txt1">Take a leisurely stroll through the streets of a traditional hot spring town<br>
                        <small>(takes about 4 hours)</small></p>
                    <div class="txt2">
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                        <p class="note">*abcdefg</p>
                    </div>
                </div>

                <div class="para -route2">
                    <p class="img"><span></span></p>
                    <p class="txt1">Take a leisurely stroll through the streets of a traditional hot spring town<br>
                        <small>(takes about 4 hours)</small></p>
                    <div class="txt2">
                        <p class="day">Day 1</p>
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                        <p class="day">Day 2</p>
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                    </div>
                </div>

                <div class="para -route3">
                    <p class="img"><span></span></p>
                    <p class="txt1">Take a leisurely stroll through the streets of a traditional hot spring town<br>
                        <small>(takes about 4 hours)</small></p>
                    <div class="txt2">
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                    </div>
                </div>

                <div class="para -route4 -noImg">
                    <p class="txt1">Take a leisurely stroll through the streets of a traditional hot spring town<br>
                        <small>(takes about 4 hours)</small></p>
                    <div class="txt2">
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                    </div>
                </div>

                <div class="para -route5">
                    <p class="img"><span></span></p>
                    <p class="txt1">Take a leisurely stroll through the streets of a traditional hot spring town<br>
                        <small>(takes about 4 hours)</small></p>
                    <div class="txt2">
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                    </div>
                </div>

                <div class="para -route6">
                    <p class="img"><span></span></p>
                    <p class="txt1">Take a leisurely stroll through the streets of a traditional hot spring town<br>
                        <small>(takes about 4 hours)</small></p>
                    <div class="txt2">
                        <ul>
                            <li>Misasa hot spring resort</li>
                            <li>walk 5 mins.</li>
                            <li>Kiya Ryokan inn</li>
                            <li>bus 25 mins.</li>
                            <li>Mt. Mitoku and Sanbutsuji Temple (Main Hall and Nageiredo Hall)</li>
                            <li>bus 25 mins.</li>
                            <li>Misasa hot spring resort</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="access" id="access">
                <h3 class="ttl">Access</h3>
                <p class="lead1">Total travel time may vary depending on various factors, such as the time of day.<br>
Please check online for the most up-to-date timetables and other details.</p>

                <h4 class="ttlSub">By Plane</h4>
                <div class="detail">
                    <div class="inner">
                        <div class="from">From Tokyo</div>
                        <div class="txt">
                            <ul>
                                <li>Haneda Airport</li>
                                <li>plane</li>
                                <li>Tottori Airport (Tottori Sand Dunes Conan Airport)</li>
                                <li>bus</li>
                                <li>Kurayoshi Station</li>
                                <li>bus</li>
                                <li>Misasa hot spring resort
                                    <span class="time">(Total travel time: around 3 hrs. 20 mins.)</span>
                                </li>
                                <li class="link"><a href="" target="_blank">[View on Map]</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <h4 class="ttlSub">By Plane</h4>
                <div class="detail">
                    <div class="inner">
                        <div class="from">From Tokyo</div>
                        <div class="txt">
                            <ul>
                                <li>Haneda Airport</li>
                                <li>plane</li>
                                <li>Tottori Airport (Tottori Sand Dunes Conan Airport)</li>
                                <li>bus</li>
                                <li>Kurayoshi Station</li>
                                <li>bus</li>
                                <li>Misasa hot spring resort
                                    <span class="time">(Total travel time: around 3 hrs. 20 mins.)</span>
                                </li>
                                <li class="link"><a href="" target="_blank">[View on Map]</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="facilities -reverse">
                    <p class="img"><span></span></p>
                    <div class="txt">
                        <h4 class="ttl">Accommodation Facilities</h4>
                        <p class="txt1">More than 20 traditional Japanese-style ryokan inns operate in Misasa, at which visitors can soak in and even drink water (or inhale steam) from hot springs that are rich in radon. Many of these ryokan have excellent facilities, but they can accommodate only a small number of guests. Kurayoshi City, which is a 25-minute bus ride from Misasa, has about 10 western-style hotels and about 10 ryokan inns, but there are no hot springs there.</p>
                        <div class="btn1">
                            <ul>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                        <div class="btn1 -withCaption">
                            <ul>
                                <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                                <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                                <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                                <li><span>Midashi</span><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                        <h4 class="ttl">Accommodation Facilities（サブタイトルがある場合）</h4>
                        <h5 class="ttlSub">Yokosuka</h5>
                        <p class="txt1">More than 20 traditional Japanese-style ryokan inns operate in Misasa, at which visitors can soak in and even drink water (or inhale steam) from hot springs that are rich in radon. Many of these ryokan have excellent facilities, but they can accommodate only a small number of guests. Kurayoshi City, which is a 25-minute bus ride from Misasa, has about 10 western-style hotels and about 10 ryokan inns, but there are no hot springs there.</p>
                        <div class="btn1">
                            <ul>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                        <h5 class="ttlSub">Yokosuka</h5>
                        <p class="txt1">More than 20 traditional Japanese-style ryokan inns operate in Misasa, at which visitors can soak in and even drink water (or inhale steam) from hot springs that are rich in radon. Many of these ryokan have excellent facilities, but they can accommodate only a small number of guests. Kurayoshi City, which is a 25-minute bus ride from Misasa, has about 10 western-style hotels and about 10 ryokan inns, but there are no hot springs there.</p>
                        <div class="btn1">
                            <ul>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                                <li><a href="#">Read Reviews</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="links">
                <div class="inner">
                    <div class="ttl">Links</div>
                    <div class="linkItems">
                        <ul>
                            <li><a href=""><span>Misasa Hot Springs official website</span></a></li>
                            <li><a href=""><span>Tottori Chubu Tourism <br>Promotion Organization</span></a></li>
                        </ul>
                    </div>
                    <p class="note">Please check online for more information and the latest details on these destinations.</p>
                </div>
            </div>

        </div>

        <div
            class="contentsBank"
            :class="[page === 'about' ? 'about': 'travelInfo']"
        >
            <div class="inner">
                <div class="ti" v-show="page === 'about'"><a href="javascript:void(0)"
                    v-on:click="showPage('travelInfo')"
                    v-on:keyup.enter="showPage('travelInfo')"
                    v-on:keyup.space="showPage('travelInfo')"
                >See<br>Travel Info</a></div>
                <div class="ti" v-show="page === 'travelInfo'"><a href="javascript:void(0)"
                    v-on:click="showPage('about')"
                    v-on:keyup.enter="showPage('about')"
                    v-on:keyup.space="showPage('about')"
                >Learn More<br>About This<br>Japan Heritage</a></div>
                <div class="cb">
                    <p class="txt1">Cultural Properties<br>Digital Content<br>Download Site</p>
                    <p class="txt2"><a href="https://cb.bunka.go.jp/en/contents?keyword=Japan%20Heritage">Download Japan Heritage photos and videos for free</a></p>
                </div>
            </div>
        </div>

        <div class="nearby">
            <div class="inner">
                <div class="ttl">Nearby <br class="sp-only">Japan Heritage <br class="sp-only">Sites</div>
                <div class="article">
                    <Carousel :navigationEnabled="true" :itemsToShow="3" class="d-flex" ref="slickNearby">
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">Onomichi - A Historic Port City Perfect for Wandering</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">Kamakura - A Historical and Cultural Mosaic</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">Preserving the Mountain Forests of the Kiso Region</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">xxxxx</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">xxxxx</p>
                            </a>
                        </Slide>
                    </Carousel>
                    <div class="sp-only">
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">Onomichi - A Historic Port City Perfect for Wandering</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">Kamakura - A Historical and Cultural Mosaic</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">Preserving the Mountain Forests of the Kiso Region</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">xxxxx</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">xxxxx</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="otherSites">
            <div class="inner">
                <div class="ttl">Other Sites in Same Category</div>
                <div class="article">
                    <Carousel :navigationEnabled="true" :itemsToShow="3" class="d-flex">
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">Onomichi - A Historic Port City Perfect for Wandering</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">Kamakura - A Historical and Cultural Mosaic</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">Preserving the Mountain Forests of the Kiso Region</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">xxxx</p>
                            </a>
                        </Slide>
                        <Slide>
                            <a href="" class="articleItem">
                                <p class="img"><span></span></p>
                                <p class="txt">xxxx</p>
                            </a>
                        </Slide>
                    </Carousel>
                    <div class="sp-only">
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">Onomichi - A Historic Port City Perfect for Wandering</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">Kamakura - A Historical and Cultural Mosaic</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">Preserving the Mountain Forests of the Kiso Region</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">xxxxx</p>
                        </a>
                        <a href="" class="articleItem">
                            <p class="img"><span></span></p>
                            <p class="txt">xxxxx</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div v-if="isOpen" class="vr-player">
                <div class="vr-player-mask">
                    <div class="vr-player-modal">
                        <div class="vr">
                            <button class="close-button" @click="close">×</button>
                            <iframe :src="src" frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <vr-player ref="vr"></vr-player>
    </div>
</template>

<script>
    import VideoPlayer from "../../../components/VideoPlayer/VideoPlayer";
    import VrPlayer from "@/components/VrPlayer/VrPlayer";
    import { Carousel, Slide } from 'vue3-carousel'
    import 'vue3-carousel/dist/carousel.css'

    export default {
        name: "template01",
        // eslint-disable-next-line vue/no-unused-components
        components: {VideoPlayer, VrPlayer, Carousel, Slide},
        data: function () {
            return {
                page: 'about',
                article: null,
                isOpen: false,
                hasPdf: true,
                src: '',
                settings: {
                    arrows: true,
                    slidesToShow: 2
                },
            }
        },
        methods: {
            showPage: function (page) {
                if(this.$refs['video-player']){
                    this.$refs['video-player'].pauseVideo();
                }
                this.page = page;
            },
            openVr: function ($event) {
                this.$refs.vr.open($event);
            },
            openStreaks: function ($event) {
                this.$refs.streaks.open($event);
            },
            download: function(){},
            close: function(){}
        }
    }
</script>

<style src="../Popular.scss" lang="scss" scoped />
